import { AdvancedTableSelectPopupIcon } from '@aibees/shared/features/advance-table/components/advanced-table-select-popup/components/advanced-table-select-popup-icon';
import { classnames } from '@aibees/shared/utils';
import { Button } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import type { SearchTableHeaderActionButtonProps as Props } from './types';

export const SearchTableHeaderActionButton = memo(
  ({
    className,
    title,
    icon,
    disabled,
    onClick,
    compact,
    placement,
    tooltipTitle,
  }: Props) => {
    return (
      <Styled.Wrapper
        arrow
        placement={placement || 'bottom'}
        title={
          disabled ? tooltipTitle || 'Please select some records first' : null
        }
      >
        <Button
          className={classnames('ActionButton', className)}
          disabled={disabled}
          variant="outlined"
          size="small"
          startIcon={
            icon && (
              <AdvancedTableSelectPopupIcon disabled={disabled} name={icon} />
            )
          }
          onClick={onClick}
        >
          {title && !compact && title}
        </Button>
      </Styled.Wrapper>
    );
  }
);

SearchTableHeaderActionButton.displayName = 'SearchTableHeaderActionButton';
